export type LuckyBirdCodeStatus = (typeof luckyBirdCodeStatus)[keyof typeof luckyBirdCodeStatus]
export const luckyBirdCodeStatus = {
  new: 0,
  used: 1,
  partiallyRedeemed: 2,
  fullyRedeemed: 3,
} as const
